import { apiRequest } from '../../apiCall'


export const getUserProfile = () => apiRequest('User.GetProfile')
export const postUpdateProfile = (params) => apiRequest('User.UpdateProfile', { ...params })
export const postChangePassword = (params) => apiRequest('User.ChangePassword', { ...params })
export const uploadProfilePhoto = (params) => {
      
    return (apiRequest('UserImage.UploadProfilePicture', { ...params }))
}
export const getProfilePhoto = (userName) => apiRequest('UserImage.GetProfilePhoto', {}, `?userName=${userName}`)
